import Vue from "vue";
import store from "./store";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import Vant from "vant";
import "vant/lib/index.css";
import "amfe-flexible";
import "./utils/remLimit";
import "./styles/layout.scss";
import { initSafeAreaInsets } from "./utils/safeArea";
import { resetApiBase, getStoredApiBaseUrl } from "./utils/bootstrap";

Vue.config.productionTip = false;

// 全局引入
Vue.use(Vant);

const BALANCE_POLL_INTERVAL = 5 * 1000;

function pollTask() {
  if (!store.getters.isLoggedIn) return;
  if (!getStoredApiBaseUrl()) return;
  store.dispatch("getBalance").catch(() => {});
}

let balancePollTimer = null;

function startBalancePoll() {
  if (balancePollTimer) return;
  pollTask();
  balancePollTimer = setInterval(pollTask, BALANCE_POLL_INTERVAL);
}

function stopBalancePoll() {
  if (!balancePollTimer) return;
  clearInterval(balancePollTimer);
  balancePollTimer = null;
}

store.watch(
  (state) => state.token,
  (token) => {
    if (token) {
      startBalancePoll();
    } else {
      stopBalancePoll();
    }
  },
  { immediate: true }
);

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
});

window.__VUE_I18N__ = i18n;

resetApiBase();
app.$mount("#app");
initSafeAreaInsets();
